// ADO-2262: the JS side of the motion tokens in tokens.css (the ShopLink 2.0 prototype's
// motion system). CSS runs every animation; JS only needs the lengths, to wait out an
// exit when the browser never reports its end (a background tab, a cancelled transition),
// and whether the user asked for reduced motion, in which case nothing waits.
// motion.spec.ts keeps these in step with the tokens.

/**
 * The `--motion-*` durations in tokens.css, in ms. `--motion-progress-fill` and
 * `--motion-collapse-fade-delay` are CSS only and have no mirror here.
 */
export const MOTION_MS = {
  fast: 150,
  base: 420,
  slow: 420,
  exitFast: 105,
  exitBase: 294,
  exitSlow: 294,
  toastSwap: 120,
  toastEnter: 300,
  badgePop: 800,
} as const;

/** How long past an exit's length a close waits for a `transitionend` that never came. */
export const EXIT_GRACE_MS = 100;

export function prefersReducedMotion(): boolean {
  return (
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
